// extracted by mini-css-extract-plugin
export default {"wrapper":"Document_wrapper__lh46M","container":"Document_container__d5Lz2"};